import { useEffect, useState } from 'react';
import { isAfter } from 'date-fns';
import { sanitizeToDate } from '@/util/timerHooks';

const useTimeIsAfter = (reference: string | number | Date) => {
  const now = new Date();
  const [value, setValue] = useState(isAfter(now, sanitizeToDate(reference) ?? now));

  useEffect(() => {
    const now = Date.now();
    const millisUntilIsAfter = (sanitizeToDate(reference)?.getTime() ?? now) - now;

    if (millisUntilIsAfter <= 0) {
      setValue(true);
      return;
    } else {
      const timeoutHandle = setTimeout(() => {
        setValue(true);
      }, millisUntilIsAfter);

      return () => clearTimeout(timeoutHandle);
    }
  }, [reference]);

  return value;
};

export default useTimeIsAfter;
